// JS for more/less button, see MoreLessHelper
export default function () {
  document.addEventListener('click', (e) => {
    const trigger = e.target;
    const panelId = trigger.dataset['moreLessToggleId'];
    if (panelId) {
      e.preventDefault();
      const panel = document.getElementById(panelId);
      if (panel) {
        const currentText = trigger.innerHTML;
        const toggleText = trigger.dataset['toggleText'];
        trigger.innerHTML = toggleText;
        trigger.dataset['toggleText'] = currentText;
        trigger.classList.toggle('btn-toggle--is-open');
        trigger.classList.toggle('btn-toggle--is-closed');
        panel.classList.toggle('hidden');
      }
    }
  });
}
